const buffersEqual = (a: ArrayBuffer, b: ArrayBuffer): boolean => {
  if (a.byteLength !== b.byteLength) {
    return false;
  }

  const viewA = new Uint8Array(a);
  const viewB = new Uint8Array(b);

  return viewA.every((byte, index) => byte === viewB[index]);
};

export const isKeyRotated = (subscription: PushSubscription, currentKey: ArrayBuffer): boolean => {
  const existingKey = subscription.options.applicationServerKey;
  return !existingKey || !buffersEqual(existingKey, currentKey);
};
